import React from 'react';

interface NoteFieldProps {
  label: string;
  id: string;
  value?: string | string[];
  onChange: (value: string) => void;
  isSelected?: boolean;
  onSelect?: () => void;
  limit?: boolean;
}

const NoteField: React.FC<NoteFieldProps> = ({
  label,
  id,
  value = '',
  onChange,
  isSelected,
  onSelect,
  limit = true
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const words = e.target.value.trim().split(/\s+/).filter(Boolean);
    if (limit && words.length > 100) {
      return;
    }
    onChange(e.target.value);
  };

  const wordCount = String(value).trim().split(/\s+/).filter(Boolean).length;

  return (
    <div className="flex flex-col w-full">
      <p className="text-[12px] font-medium leading-[normal] text-[#959595] m-0 mb-[8px]">
        {label}
      </p>
      <div>
        <textarea
          id={id}
          name={label}
          className="text-[#321A50] text-[15px] font-medium leading-[normal] h-[100px] bg-white p-0 w-full p-4 rounded-lg shadow-sm border-2 border-[#E7E7E7] max-w-xl box-border"
          value={value}
          onChange={handleChange}
        />
        {limit && (
          <p
            className={`text-[10px] text-[#959595] mt-1 mb-0 text-right ${wordCount >= 100 ? 'text-red-500' : 'text-gray-500'}`}
          >
            {wordCount}/100 words
          </p>
        )}
      </div>
      {onSelect && (
        <div className="mt-[10px]">
          <button
            onClick={onSelect}
            className={`inline-flex items-center rounded-full px-3 py-2 border transition-all duration-200 hover:shadow-sm group ${
              isSelected
                ? 'bg-white border-orange-200 hover:bg-orange-50'
                : 'bg-white border-gray-200 hover:bg-gray-50'
            }`}
            style={{ border: '1px solid #E0E0E0' }}
          >
            <div
              className={`w-5 h-5 rounded-full flex items-center justify-center mr-2 transition-colors duration-200 group-hover:bg-[#EE731B] ${
                isSelected ? 'bg-[#EE731B]' : 'bg-gray-400'
              }`}
            >
              <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            </div>

            <p
              className={`text-[14px] leading-[22px] font-[550] transition-colors duration-200 group-hover:text-[#EE731B] my-0 ${
                isSelected ? 'text-[#EE731B]' : 'text-gray-500'
              }`}
            >
              Show to user
            </p>
          </button>
        </div>
      )}
    </div>
  );
};

export default NoteField;
